module.exports = __webpack_public_path__ + "static/img/促销背景@2x.a877a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/促销背景@2x.png
// module id = dA5V
// module chunks = 192